import { Trans, useTranslation } from "react-i18next";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/outline";
import andreas from "../assets/images/limon_andreas.png";

const Contact = () => {
  const { t } = useTranslation();

  return (
    <section className="mt-40 lg:mt-11">
      <div className="bg-allsafe-grey shadow-lg px-4 mx-4 lg:pl-11 lg:pr-28 lg:py-8 md:max-w-[71%] lg:max-w-5xl md:mx-auto">
        <div className="relative -top-20 lg:top-0">
          <div className="flex flex-col-reverse items-center lg:flex-row justify-between">
            <div className="max-w-lg">
              <h2 className="text-4xl leading-10 font-Roboto font-bold pb-2 my-8 lg:my-0">
                {t("Ergreifen Sie Ihre Chance!")}
              </h2>
              <div className="font-Roboto">
                <Trans>
									Reduzieren Sie mit unseren Produkten Ihren CO2 Fußabdruck und
									erreichen Sie so ihre Klimaziele. Die Ressourcen des
									nachhaltigeren Aluminiums sind begrenzt und stark nachgefragt.
									Sprechen Sie uns an und seien Sie dabei.
                </Trans>
              </div>
              <div className="mt-4 2xl:mt-4">
                <div className="mb-3 2xl:mb-5">
                  <div className="flex gap-x-8 items-center">
                    <div className="w-5 h-5 2xl:w-8 2xl:h-8">
                      <PhoneIcon color="#1D4376" />
                    </div>
                    <a
                      className="text-base leading-6 text-allsafe-blue font-Roboto font-light cursor-pointer 2xl:text-2xl 2xl:leading-8"
                      href="tel:+49 (0) 7733 50 02 258"
                    >
											+49 (0) 7733 50 02 258
                    </a>
                  </div>
                </div>
                <div className="flex gap-x-8 items-center">
                  <div className="w-5 h-5 2xl:w-8 2xl:w-8">
                    <EnvelopeIcon color="#1D4376" />
                  </div>
                  <a
                    className="text-base leading-6 text-allsafe-blue font-Roboto font-light cursor-pointer 2xl:text-2xl 2xl:leading-8"
                    href="mailto:Andreas.Limon@allsafe-group.com"
                  >
										Andreas.Limon@allsafe-group.com
                  </a>
                </div>
              </div>
            </div>
            <figure className="flex flex-col items-center w-48">
              <img
                src={andreas}
                alt="Trulli"
                className="w-full object-contain"
              />
              <figcaption className="font-Roboto font-light">
								Andreas Limon
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
